export enum ToastTypes {
  SUCCESS,
  ERROR,
  WARNING,
}
export interface Toast {
  id: string;
  title: string;
  description: string;
  shouldShowClose: boolean;
  borderColour: string;
  backgroundColour: string;
  icon: string;
  iconColour: string;
  colour: string;
  type: ToastTypes;
  errorCode?: string;
}
export interface ToastEvent {
  type: ToastTypes;
  title: string;
  description: string;
  errorCode?: string;
}